export default __webpack_public_path__ + "static/media/Realcase-socialMedia-en.1d881454.png";